import { buildBaseProps, buildScoresData } from "../../helpers";
var TennisMatchType;
(function (TennisMatchType) {
    TennisMatchType["ThreeSet"] = "3";
    TennisMatchType["FiveSet"] = "5";
    TennisMatchType["Default"] = "Default";
})(TennisMatchType || (TennisMatchType = {}));
const scoreKeys = {
    [TennisMatchType.ThreeSet]: [
        { header: "FirstSetHeader", team1Key: "firstSetScore1", team2Key: "firstSetScore2", translatable: true, gamePart: "FirstSet" },
        { header: "SecondSetHeader", team1Key: "secondSetScore1", team2Key: "secondSetScore2", translatable: true, gamePart: "SecondSet" },
        { header: "ThirdSetHeader", team1Key: "thirdSetScore1", team2Key: "thirdSetScore2", translatable: true, gamePart: "ThirdSet" },
        { header: "Sets", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" },
        { header: "TennisPoints", team1Key: "currentGameScore1", team2Key: "currentGameScore2", translatable: true, gamePart: "" }
    ],
    [TennisMatchType.FiveSet]: [
        { header: "FirstSetHeader", team1Key: "firstSetScore1", team2Key: "firstSetScore2", translatable: true, gamePart: "FirstSet" },
        { header: "SecondSetHeader", team1Key: "secondSetScore1", team2Key: "secondSetScore2", translatable: true, gamePart: "SecondSet" },
        { header: "ThirdSetHeader", team1Key: "thirdSetScore1", team2Key: "thirdSetScore2", translatable: true, gamePart: "ThirdSet" },
        { header: "FourthSetHeader", team1Key: "fourthSetScore1", team2Key: "fourthSetScore2", translatable: true, gamePart: "FourthSet" },
        { header: "FifthSetHeader", team1Key: "fifthSetScore1", team2Key: "fifthSetScore2", translatable: true, gamePart: "FifthSet" },
        { header: "Sets", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" },
        { header: "TennisPoints", team1Key: "currentGameScore1", team2Key: "currentGameScore2", translatable: true, gamePart: "" }
    ],
    [TennisMatchType.Default]: [
        { header: "Sets", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" },
        { header: "TennisPoints", team1Key: "currentGameScore1", team2Key: "currentGameScore2", translatable: true, gamePart: "" }
    ]
};
export const buildTennisLiveMobileProps = (event, config) => {
    const matchType = event.tennisMatchType || "Default";
    const scoresData = buildScoresData(event, scoreKeys[matchType], config);
    return Object.assign(Object.assign({}, buildBaseProps(event, config.dict)), { team1Scores: scoresData.team1Scores, team2Scores: scoresData.team2Scores, header: scoresData.headers, onServe: event.scores.onServe, sportId: event.sportId });
};
//# sourceMappingURL=buildTennisLiveMobileProps.js.map